"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5621],{

/***/ 31828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ Mode; },
/* harmony export */   "FX": function() { return /* binding */ ExternalProvider; },
/* harmony export */   "MP": function() { return /* binding */ ConditionLocationType; },
/* harmony export */   "QB": function() { return /* binding */ vsTriggerType; },
/* harmony export */   "XI": function() { return /* binding */ GameStatus; },
/* harmony export */   "_B": function() { return /* binding */ PAGE_PATH; },
/* harmony export */   "o2": function() { return /* binding */ ShowcaseElement; }
/* harmony export */ });
/* unused harmony export TItemsFilter */
var TItemsFilter;
(function(TItemsFilter) {
    TItemsFilter[TItemsFilter["Tags"] = 0] = "Tags";
    TItemsFilter[TItemsFilter["Sweeps"] = 1] = "Sweeps";
})(TItemsFilter || (TItemsFilter = {}));
var Mode;
(function(Mode) {
    Mode[Mode["day"] = 3] = "day";
    Mode[Mode["week"] = 21] = "week";
    Mode[Mode["month"] = 90] = "month";
})(Mode || (Mode = {}));
var PAGE_PATH;
(function(PAGE_PATH) {
    PAGE_PATH["ALL"] = "all";
    PAGE_PATH["TOUR"] = "tour";
    PAGE_PATH["EXPERIENCE"] = "experience";
    PAGE_PATH["ECOMMERCE"] = "e-commerce-tour";
})(PAGE_PATH || (PAGE_PATH = {}));
var ConditionLocationType;
(function(ConditionLocationType) {
    ConditionLocationType["sweep"] = "sweep";
    ConditionLocationType["tourLink"] = "tourLink";
})(ConditionLocationType || (ConditionLocationType = {}));
var GameStatus;
(function(GameStatus) {
    GameStatus["NotStarted"] = "not_started";
    GameStatus["Started"] = "started";
    GameStatus["OutroClip"] = "outro_clip";
    GameStatus["SuccessfullyEnded"] = "successfully_ended";
    GameStatus["SuccessfullyEndedWithoutFinalScreen"] = "successfully_ended_without_final_screen";
    GameStatus["SuccessfullyEndedWithSimpleFinalScreen"] = "successfully_ended_with_simple_final_screen";
    GameStatus["TimeIsUpEnded"] = "timup_ended";
})(GameStatus || (GameStatus = {}));
var ExternalProvider;
(function(ExternalProvider) {
    ExternalProvider["SHOPIFY"] = "shopify";
    ExternalProvider["OPTICAL_CENTER"] = "opticalCenter";
    ExternalProvider["HAVELLS"] = "havells";
})(ExternalProvider || (ExternalProvider = {}));
var vsTriggerType;
(function(vsTriggerType) {
    vsTriggerType["default"] = "default";
    vsTriggerType["revealCondition"] = "revealCondition";
})(vsTriggerType || (vsTriggerType = {}));
var ShowcaseElement;
(function(ShowcaseElement) {
    ShowcaseElement["TagPanel"] = "TAG_PANEL";
    ShowcaseElement["TagPanelHeader"] = "TAG_PANEL_HEADER";
    ShowcaseElement["LoaderPowerBy"] = "LOADER_POWER_BY";
    ShowcaseElement["LoaderPresentedBy"] = "LOADER_PRESENTED_BY";
    ShowcaseElement["TagEmbedMedia"] = "TAG_EMBED_MEDIA";
    ShowcaseElement["ErrorContainer"] = "ERROR_CONTAINER";
    ShowcaseElement["VRLayer"] = "VR_LAYER";
})(ShowcaseElement || (ShowcaseElement = {}));


/***/ }),

/***/ 47835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./units/Icon/index.ts + 53 modules
var Icon = __webpack_require__(95829);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./units/Alert/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.75rem 1.25rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n\n  background-color: ",
        ";\n  color: ",
        ";\n  border-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var backgroundColor = {
    info: "#cce5ff",
    warning: "#fff3cd",
    error: "#f8d7da",
    success: "#d4edda"
};
var borderColor = {
    info: "#b8daff",
    warning: "#ffeeba",
    error: "#f5c6cb",
    success: "#c3e6cb"
};
var color = {
    info: "#004085",
    warning: "#856404",
    error: "#721c24",
    success: "#155724"
};
var AlertStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__AlertStyled",
    componentId: "sc-deb339e0-0"
})(_templateObject(), function(param) {
    var type = param.type;
    return backgroundColor[type];
}, function(param) {
    var type = param.type;
    return color[type];
}, function(param) {
    var type = param.type;
    return borderColor[type];
});

;// CONCATENATED MODULE: ./units/Alert/index.tsx






var getIcon = function(type) {
    switch(type){
        case "warning":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Warning */.Z.Warning, {});
            }
        case "error":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ExclamationMark */.Z.ExclamationMark, {});
            }
        case "success":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Check */.Z.Check, {});
            }
        case "info":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Info */.Z.Info, {});
            }
        default:
            return null;
    }
};
var Alert = function(_param) {
    var id = _param.id, type = _param.type, show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "type",
        "show",
        "children"
    ]);
    if (show) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            id: id,
            type: type
        }, restProps), {
            children: [
                getIcon(type),
                children
            ]
        }));
    }
    return null;
};
/* harmony default export */ var units_Alert = (Alert);


/***/ }),

/***/ 95829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Icon; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(81645);
;// CONCATENATED MODULE: ./units/Icon/ArrowDown.tsx




var Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Down"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M112 268l144 144 144-144M256 392V100"
            })
        ]
    }));
};
/* harmony default export */ var ArrowDown = (Icon);

;// CONCATENATED MODULE: ./units/Icon/ArrowUp.tsx




var ArrowUp_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Up"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M112 244l144-144 144 144M256 120v292"
            })
        ]
    }));
};
/* harmony default export */ var ArrowUp = (ArrowUp_Icon);

;// CONCATENATED MODULE: ./units/Icon/ArrowRight.tsx




var ArrowRight_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Arrow Right"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z"
            })
        ]
    }));
};
/* harmony default export */ var ArrowRight = (ArrowRight_Icon);

;// CONCATENATED MODULE: ./units/Icon/ChevronDown.tsx




var ChevronDown_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Down"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M112 184l144 144 144-144"
            })
        ]
    }));
};
/* harmony default export */ var ChevronDown = (ChevronDown_Icon);

;// CONCATENATED MODULE: ./units/Icon/ChevronLeft.tsx




var ChevronLeft_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "48",
            d: "M328 112L184 256l144 144"
        })
    }));
};
/* harmony default export */ var ChevronLeft = (ChevronLeft_Icon);

;// CONCATENATED MODULE: ./units/Icon/ChevronRight.tsx




var ChevronRight_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Forward"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "48",
                d: "M184 112l144 144-144 144"
            })
        ]
    }));
};
/* harmony default export */ var ChevronRight = (ChevronRight_Icon);

;// CONCATENATED MODULE: ./units/Icon/Close.tsx




var Close_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Close"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M368 368L144 144M368 144L144 368"
            })
        ]
    }));
};
/* harmony default export */ var Close = (Close_Icon);

;// CONCATENATED MODULE: ./units/Icon/ColorPalette.tsx




var ColorPalette_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Color Palette"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M430.11 347.9c-6.6-6.1-16.3-7.6-24.6-9-11.5-1.9-15.9-4-22.6-10-14.3-12.7-14.3-31.1 0-43.8l30.3-26.9c46.4-41 46.4-108.2 0-149.2-34.2-30.1-80.1-45-127.8-45-55.7 0-113.9 20.3-158.8 60.1-83.5 73.8-83.5 194.7 0 268.5 41.5 36.7 97.5 55 152.9 55.4h1.7c55.4 0 110-17.9 148.8-52.4 14.4-12.7 11.99-36.6.1-47.7z",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "144",
                cy: "208",
                r: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "152",
                cy: "311",
                r: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "224",
                cy: "144",
                r: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "256",
                cy: "367",
                r: "48"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "328",
                cy: "144",
                r: "32"
            })
        ]
    }));
};
/* harmony default export */ var ColorPalette = (ColorPalette_Icon);

;// CONCATENATED MODULE: ./units/Icon/Droplet.tsx




var Droplet_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0.652 0.759 9.825 13.46",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M5.565.759l-.557.557c-.18.18-4.356 4.405-4.356 7.99a4.927 4.927 0 0 0 4.913 4.913 4.927 4.927 0 0 0 4.912-4.912c0-3.57-4.176-7.811-4.356-7.991L5.565.759zM3.108 8.488a.81.81 0 0 1 .819.819c0 .9.737 1.637 1.638 1.637a.81.81 0 0 1 .818.819.81.81 0 0 1-.818.819A3.285 3.285 0 0 1 2.29 9.307a.81.81 0 0 1 .818-.82z"
        })
    }));
};
/* harmony default export */ var Droplet = (Droplet_Icon);

;// CONCATENATED MODULE: ./units/Icon/Edit.tsx




var Edit_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Edit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
            })
        ]
    }));
};
/* harmony default export */ var Edit = (Edit_Icon);

;// CONCATENATED MODULE: ./units/Icon/ExpandArrowsAlt.tsx




var ExpandArrowsAlt_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
        })
    }));
};
/* harmony default export */ var ExpandArrowsAlt = (ExpandArrowsAlt_Icon);

;// CONCATENATED MODULE: ./units/Icon/Filter.tsx




var Filter_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Chevron Forward"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
            })
        ]
    }));
};
/* harmony default export */ var Filter = (Filter_Icon);

;// CONCATENATED MODULE: ./units/Icon/Image.tsx




var Image_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "48",
                y: "80",
                width: "416",
                height: "352",
                rx: "48",
                ry: "48",
                fill: "none",
                stroke: "currentColor",
                strokeLinejoin: "round",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "336",
                cy: "176",
                r: "32",
                fill: "none",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeWidth: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M304 335.79l-90.66-90.49a32 32 0 00-43.87-1.3L48 352M224 432l123.34-123.34a32 32 0 0143.11-2L464 368",
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32"
            })
        ]
    }));
};
/* harmony default export */ var Image = (Image_Icon);

;// CONCATENATED MODULE: ./units/Icon/Layout.tsx




var Layout_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Layout"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x1: "3",
                y1: "9",
                x2: "21",
                y2: "9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x1: "9",
                y1: "21",
                x2: "9",
                y2: "9"
            })
        ]
    }));
};
/* harmony default export */ var Layout = (Layout_Icon);

;// CONCATENATED MODULE: ./units/Icon/Loading.tsx




var Loading_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 1024 1024",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Loading"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
            })
        ]
    }));
};
/* harmony default export */ var Loading = (Loading_Icon);

;// CONCATENATED MODULE: ./units/Icon/Lock.tsx




var Lock_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 16 18",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Lock"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.84375 13.5C8.84375 13.9676 8.46758 14.3438 8 14.3438C7.53242 14.3438 7.15625 13.9676 7.15625 13.5V11.25C7.15625 10.7824 7.53242 10.4062 8 10.4062C8.46758 10.4062 8.84375 10.7824 8.84375 11.25V13.5ZM8 0C10.4855 0 12.5 2.0148 12.5 4.5V6.75H13.625C14.866 6.75 15.875 7.75898 15.875 9V15.75C15.875 16.991 14.866 18 13.625 18H2.375C1.13223 18 0.125 16.991 0.125 15.75V9C0.125 7.75898 1.13223 6.75 2.375 6.75H3.5V4.5C3.5 2.0148 5.51445 0 8 0ZM8 1.6875C6.44609 1.6875 5.1875 2.9468 5.1875 4.5V6.75H10.8125V4.5C10.8125 2.9468 9.55391 1.6875 8 1.6875ZM2.375 8.4375C2.06422 8.4375 1.8125 8.69063 1.8125 9V15.75C1.8125 16.0594 2.06422 16.3125 2.375 16.3125H13.625C13.9344 16.3125 14.1875 16.0594 14.1875 15.75V9C14.1875 8.69063 13.9344 8.4375 13.625 8.4375H2.375Z",
                fill: "currentColor"
            })
        ]
    }));
};
/* harmony default export */ var Lock = (Lock_Icon);

;// CONCATENATED MODULE: ./units/Icon/MetroShrink.tsx




var MetroShrink_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0.5 15 15",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M7.875 7.125h5.688l-2.188-2.188L14 2.312 12.687 1l-2.625 2.625-2.187-2.188v5.688zm0 1.75v5.687l2.187-2.187L12.687 15 14 13.687l-2.625-2.625 2.188-2.187H7.875zm-1.75 0H.437l2.188 2.187L0 13.687 1.313 15l2.624-2.625 2.188 2.187V8.875zm0-1.75V1.437L3.937 3.625 1.313 1 0 2.312l2.625 2.625L.437 7.125h5.688z"
        })
    }));
};
/* harmony default export */ var MetroShrink = (MetroShrink_Icon);

;// CONCATENATED MODULE: ./units/Icon/Redo.tsx




var Redo_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "14",
        viewBox: "0.081 0.138 15.684 13.723",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M7.923.138c2.165 0 4.126.878 5.545 2.298L15.765.138V6.02H9.884l2.198-2.198a5.882 5.882 0 1 0-8.049 8.57l-1.297 1.47A7.842 7.842 0 0 1 7.923.139z"
        })
    }));
};
/* harmony default export */ var Redo = (Redo_Icon);

;// CONCATENATED MODULE: ./units/Icon/Resize.tsx




var Resize_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "16",
        viewBox: "0.321 0.356 15.289 15.289",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M7.966.356l3.172 3.172-7.644 7.644L.32 8v7.644h7.645l-3.173-3.172 7.645-7.644L15.61 8V.356H7.966z"
        })
    }));
};
/* harmony default export */ var Resize = (Resize_Icon);

;// CONCATENATED MODULE: ./units/Icon/Ruler.tsx




var Ruler_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0.375 15 11.25",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M14.716 4.382l-1.842-3.137A.745.745 0 0 0 11.867.98l-1.598.905 1.382 2.354a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.251-.067L9.63 2.247l-1.277.725.646 1.097a.18.18 0 0 1-.068.248l-.319.18a.185.185 0 0 1-.252-.067l-.646-1.095-1.278.725L7.82 6.414a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.251-.067L5.799 4.421l-1.277.725.646 1.097a.18.18 0 0 1-.068.247l-.319.181a.185.185 0 0 1-.252-.067l-.646-1.1-1.278.725 1.382 2.354a.18.18 0 0 1-.067.248l-.32.18a.185.185 0 0 1-.252-.067L1.966 6.597.37 7.502a.72.72 0 0 0-.27.99l1.842 3.14a.745.745 0 0 0 1.007.266l11.5-6.526a.718.718 0 0 0 .268-.99z"
        })
    }));
};
/* harmony default export */ var Ruler = (Ruler_Icon);

;// CONCATENATED MODULE: ./units/Icon/Search.tsx




var Search_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "11",
                cy: "11",
                r: "8",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "21",
                y1: "21",
                x2: "16.65",
                y2: "16.65",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var Search = (Search_Icon);

;// CONCATENATED MODULE: ./units/Icon/SortAlphaDown.tsx




var SortAlphaDown_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Sort Alpha Down"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                d: "M187.298 395.314l-79.984 80.002c-6.248 6.247-16.383 6.245-22.627 0L4.705 395.314C-5.365 385.244 1.807 368 16.019 368H64V48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v320h47.984c14.241 0 21.363 17.264 11.314 27.314zm119.075-180.007A12 12 0 0 1 294.838 224h-35.717c-8.22 0-14.007-8.078-11.362-15.861l57.096-168A12 12 0 0 1 316.217 32h39.566c5.139 0 9.708 3.273 11.362 8.139l57.096 168C426.886 215.922 421.1 224 412.879 224h-35.735a12 12 0 0 1-11.515-8.622l-8.301-28.299h-42.863l-8.092 28.228zm22.857-78.697h13.367l-6.6-22.937-6.767 22.937zm12.575 287.323l67.451-95.698a12 12 0 0 0 2.192-6.913V300c0-6.627-5.373-12-12-12H274.522c-6.627 0-12 5.373-12 12v28.93c0 6.627 5.373 12 12 12h56.469c-.739.991-1.497 2.036-2.27 3.133l-67.203 95.205a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h129.355c6.627 0 12-5.373 12-12v-28.93c0-6.627-5.373-12-12-12h-61.146c.74-.993 1.5-2.039 2.274-3.137z"
            })
        ]
    }));
};
/* harmony default export */ var SortAlphaDown = (SortAlphaDown_Icon);

;// CONCATENATED MODULE: ./units/Icon/SortAlphaUp.tsx




var SortAlphaUp_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 448 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Sort Alpha Up"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                d: "M4.702 116.686l79.984-80.002c6.248-6.247 16.383-6.245 22.627 0l79.981 80.002c10.07 10.07 2.899 27.314-11.314 27.314H128v320c0 8.837-7.163 16-16 16H80c-8.837 0-16-7.163-16-16V144H16.016c-14.241 0-21.363-17.264-11.314-27.314zm301.671 98.621A12 12 0 0 1 294.838 224h-35.717c-8.22 0-14.007-8.078-11.362-15.861l57.096-168A12 12 0 0 1 316.217 32h39.566c5.139 0 9.708 3.273 11.362 8.139l57.096 168C426.886 215.922 421.1 224 412.879 224h-35.735a12 12 0 0 1-11.515-8.622l-8.301-28.299h-42.863l-8.092 28.228zm22.857-78.697h13.367l-6.6-22.937-6.767 22.937zm12.575 287.323l67.451-95.698a12 12 0 0 0 2.192-6.913V300c0-6.627-5.373-12-12-12H274.522c-6.627 0-12 5.373-12 12v28.93c0 6.627 5.373 12 12 12h56.469c-.739.991-1.497 2.036-2.27 3.133l-67.203 95.205a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h129.355c6.627 0 12-5.373 12-12v-28.93c0-6.627-5.373-12-12-12h-61.146c.74-.993 1.5-2.039 2.274-3.137z"
            })
        ]
    }));
};
/* harmony default export */ var SortAlphaUp = (SortAlphaUp_Icon);

;// CONCATENATED MODULE: ./units/Icon/Tag.tsx




var Tag_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Tag"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                x1: "7",
                y1: "7",
                x2: "7.01",
                y2: "7"
            })
        ]
    }));
};
/* harmony default export */ var Tag = (Tag_Icon);

;// CONCATENATED MODULE: ./units/Icon/ToggleOn.tsx




var ToggleOn_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0.5 0 15 10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M10.05 0h-5c-2.76 0-5 2.24-5 5s2.24 5 5 5h5c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8.333A3.331 3.331 0 0 1 6.717 5a3.331 3.331 0 0 1 3.333-3.333A3.332 3.332 0 0 1 13.383 5a3.332 3.332 0 0 1-3.333 3.333z"
        })
    }));
};
/* harmony default export */ var ToggleOn = (ToggleOn_Icon);

;// CONCATENATED MODULE: ./units/Icon/ToggleOff.tsx




var ToggleOff_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0.167 16 10.667",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            paintOrder: "stroke fill markers",
            fillRule: "evenodd",
            d: "M10.6.5h-5a5 5 0 1 0 0 10h5a5 5 0 1 0 0-10zm-8.333 5A3.331 3.331 0 0 1 5.6 2.167 3.331 3.331 0 0 1 8.933 5.5 3.332 3.332 0 0 1 5.6 8.833 3.331 3.331 0 0 1 2.267 5.5zM10.6 8.833H9.326a4.998 4.998 0 0 0 0-6.666H10.6A3.332 3.332 0 0 1 13.933 5.5 3.332 3.332 0 0 1 10.6 8.833z"
        })
    }));
};
/* harmony default export */ var ToggleOff = (ToggleOff_Icon);

;// CONCATENATED MODULE: ./units/Icon/Undo.tsx




var Undo_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "16",
        height: "14",
        viewBox: "0.081 0.138 15.684 13.723",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "scale(-1, 1)",
            "transform-origin": "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                paintOrder: "stroke fill markers",
                fillRule: "evenodd",
                d: "M7.923.138c2.165 0 4.126.878 5.545 2.298L15.765.138V6.02H9.884l2.198-2.198a5.882 5.882 0 1 0-8.049 8.57l-1.297 1.47A7.842 7.842 0 0 1 7.923.139z"
            })
        })
    }));
};
/* harmony default export */ var Undo = (Undo_Icon);

;// CONCATENATED MODULE: ./units/Icon/Upload.tsx




var Upload_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "none",
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                points: "17 8 12 3 7 8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "12",
                y1: "3",
                x2: "12",
                y2: "15"
            })
        ]
    }));
};
/* harmony default export */ var Upload = (Upload_Icon);

;// CONCATENATED MODULE: ./units/Icon/Public.tsx




var Public_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Public"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
            })
        ]
    }));
};
/* harmony default export */ var Public = (Public_Icon);

;// CONCATENATED MODULE: ./units/Icon/Add.tsx




var Add_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Add"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
            })
        ]
    }));
};
/* harmony default export */ var Add = (Add_Icon);

;// CONCATENATED MODULE: ./units/Icon/Print.tsx




var Print = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
        })
    }));
};
/* harmony default export */ var Icon_Print = (Print);

;// CONCATENATED MODULE: ./units/Icon/Star.tsx




var Star_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Star"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M287.9 0C297.1 0 305.5 5.25 309.5 13.52L378.1 154.8L531.4 177.5C540.4 178.8 547.8 185.1 550.7 193.7C553.5 202.4 551.2 211.9 544.8 218.2L433.6 328.4L459.9 483.9C461.4 492.9 457.7 502.1 450.2 507.4C442.8 512.7 432.1 513.4 424.9 509.1L287.9 435.9L150.1 509.1C142.9 513.4 133.1 512.7 125.6 507.4C118.2 502.1 114.5 492.9 115.1 483.9L142.2 328.4L31.11 218.2C24.65 211.9 22.36 202.4 25.2 193.7C28.03 185.1 35.5 178.8 44.49 177.5L197.7 154.8L266.3 13.52C270.4 5.249 278.7 0 287.9 0L287.9 0zM287.9 78.95L235.4 187.2C231.9 194.3 225.1 199.3 217.3 200.5L98.98 217.9L184.9 303C190.4 308.5 192.9 316.4 191.6 324.1L171.4 443.7L276.6 387.5C283.7 383.7 292.2 383.7 299.2 387.5L404.4 443.7L384.2 324.1C382.9 316.4 385.5 308.5 391 303L476.9 217.9L358.6 200.5C350.7 199.3 343.9 194.3 340.5 187.2L287.9 78.95z"
            })
        ]
    }));
};
/* harmony default export */ var Star = (Star_Icon);

;// CONCATENATED MODULE: ./units/Icon/StarSolid.tsx




var StarSolid_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Star Solid"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
            })
        ]
    }));
};
/* harmony default export */ var StarSolid = (StarSolid_Icon);

;// CONCATENATED MODULE: ./units/Icon/Bars.tsx




var Bars_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 88C0 74.75 10.75 64 24 64H424C437.3 64 448 74.75 448 88C448 101.3 437.3 112 424 112H24C10.75 112 0 101.3 0 88zM0 248C0 234.7 10.75 224 24 224H424C437.3 224 448 234.7 448 248C448 261.3 437.3 272 424 272H24C10.75 272 0 261.3 0 248zM424 432H24C10.75 432 0 421.3 0 408C0 394.7 10.75 384 24 384H424C437.3 384 448 394.7 448 408C448 421.3 437.3 432 424 432z"
            })
        })
    }));
};
/* harmony default export */ var Bars = (Bars_Icon);

;// CONCATENATED MODULE: ./units/Icon/Xmark.tsx




var Xmark_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 320 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"
            })
        })
    }));
};
/* harmony default export */ var Xmark = (Xmark_Icon);

;// CONCATENATED MODULE: ./units/Icon/GalleryThumbnails.tsx




var GalleryThumbnails_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 576 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M512 0C547.3 0 576 28.65 576 64V288C576 323.3 547.3 352 512 352H64C28.65 352 0 323.3 0 288V64C0 28.65 28.65 0 64 0H512zM512 48H64C55.16 48 48 55.16 48 64V288C48 296.8 55.16 304 64 304H512C520.8 304 528 296.8 528 288V64C528 55.16 520.8 48 512 48zM0 448C0 430.3 14.33 416 32 416H64C81.67 416 96 430.3 96 448V480C96 497.7 81.67 512 64 512H32C14.33 512 0 497.7 0 480V448zM224 416C241.7 416 256 430.3 256 448V480C256 497.7 241.7 512 224 512H192C174.3 512 160 497.7 160 480V448C160 430.3 174.3 416 192 416H224zM320 448C320 430.3 334.3 416 352 416H384C401.7 416 416 430.3 416 448V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V448zM544 416C561.7 416 576 430.3 576 448V480C576 497.7 561.7 512 544 512H512C494.3 512 480 497.7 480 480V448C480 430.3 494.3 416 512 416H544z"
            })
        })
    }));
};
/* harmony default export */ var GalleryThumbnails = (GalleryThumbnails_Icon);

;// CONCATENATED MODULE: ./units/Icon/Backpack.tsx




var Backpack_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M320 64h-16V48c0-26.47-21.53-48-48-48h-64c-26.47 0-48 21.53-48 48v16h-16C57.31 64 0 121.31 0 192v256c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V192c0-70.69-57.31-128-128-128zM176 48c0-8.83 7.19-16 16-16h64c8.81 0 16 7.17 16 16v16h-96V48zm160 432H112v-96h224v96zm0-128H112v-32c0-17.67 14.33-32 32-32h160c17.67 0 32 14.33 32 32v32zm80 96c0 17.64-14.36 32-32 32h-16V320c0-35.29-28.71-64-64-64H144c-35.29 0-64 28.71-64 64v160H64c-17.64 0-32-14.36-32-32V192c0-52.94 43.06-96 96-96h192c52.94 0 96 43.06 96 96v256zM312 160H136c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h176c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"
            })
        })
    }));
};
/* harmony default export */ var Backpack = (Backpack_Icon);

;// CONCATENATED MODULE: ./units/Icon/Book.tsx




var Book_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 512 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M356 160H188c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zm12 52v-8c0-6.6-5.4-12-12-12H188c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12zm64.7 268h3.3c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H80c-44.2 0-80-35.8-80-80V80C0 35.8 35.8 0 80 0h344c13.3 0 24 10.7 24 24v368c0 10-6.2 18.6-14.9 22.2-3.6 16.1-4.4 45.6-.4 65.8zM128 384h288V32H128v352zm-96 16c13.4-10 30-16 48-16h16V32H80c-26.5 0-48 21.5-48 48v320zm372.3 80c-3.1-20.4-2.9-45.2 0-64H80c-64 0-64 64 0 64h324.3z"
            })
        })
    }));
};
/* harmony default export */ var Book = (Book_Icon);

;// CONCATENATED MODULE: ./units/Icon/Check.tsx




var Check_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
            })
        })
    }));
};
/* harmony default export */ var Check = (Check_Icon);

;// CONCATENATED MODULE: ./units/Icon/ExclamationMark.tsx




var ExclamationMark_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
            })
        })
    }));
};
/* harmony default export */ var ExclamationMark = (ExclamationMark_Icon);

;// CONCATENATED MODULE: ./units/Icon/Info.tsx




var Info_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm0-338c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
            })
        })
    }));
};
/* harmony default export */ var Info = (Info_Icon);

;// CONCATENATED MODULE: ./units/Icon/Warning.tsx




var Warning_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 496 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm176 296H72c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h352c8.84 0 16 7.16 16 16v64c0 8.84-7.16 16-16 16z"
            })
        })
    }));
};
/* harmony default export */ var Warning = (Warning_Icon);

;// CONCATENATED MODULE: ./units/Icon/Gear.tsx




var Gear_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M160 256C160 202.1 202.1 160 256 160C309 160 352 202.1 352 256C352 309 309 352 256 352C202.1 352 160 309 160 256zM256 208C229.5 208 208 229.5 208 256C208 282.5 229.5 304 256 304C282.5 304 304 282.5 304 256C304 229.5 282.5 208 256 208zM293.1 .0003C315.3 .0003 334.6 15.19 339.8 36.74L347.6 69.21C356.1 73.36 364.2 78.07 371.9 83.28L404 73.83C425.3 67.56 448.1 76.67 459.2 95.87L496.3 160.1C507.3 179.3 503.8 203.6 487.8 218.9L463.5 241.1C463.8 246.6 464 251.3 464 256C464 260.7 463.8 265.4 463.5 270L487.8 293.1C503.8 308.4 507.3 332.7 496.3 351.9L459.2 416.1C448.1 435.3 425.3 444.4 404 438.2L371.9 428.7C364.2 433.9 356.1 438.6 347.6 442.8L339.8 475.3C334.6 496.8 315.3 512 293.1 512H218.9C196.7 512 177.4 496.8 172.2 475.3L164.4 442.8C155.9 438.6 147.8 433.9 140.1 428.7L107.1 438.2C86.73 444.4 63.94 435.3 52.85 416.1L15.75 351.9C4.66 332.7 8.168 308.4 24.23 293.1L48.47 270C48.16 265.4 48 260.7 48 255.1C48 251.3 48.16 246.6 48.47 241.1L24.23 218.9C8.167 203.6 4.66 179.3 15.75 160.1L52.85 95.87C63.94 76.67 86.73 67.56 107.1 73.83L140.1 83.28C147.8 78.07 155.9 73.36 164.4 69.21L172.2 36.74C177.4 15.18 196.7 0 218.9 0L293.1 .0003zM205.5 103.6L194.3 108.3C181.6 113.6 169.8 120.5 159.1 128.7L149.4 136.1L94.42 119.9L57.31 184.1L98.81 223.6L97.28 235.6C96.44 242.3 96 249.1 96 256C96 262.9 96.44 269.7 97.28 276.4L98.81 288.4L57.32 327.9L94.42 392.1L149.4 375.9L159.1 383.3C169.8 391.5 181.6 398.4 194.3 403.7L205.5 408.4L218.9 464H293.1L306.5 408.4L317.7 403.7C330.4 398.4 342.2 391.5 352.9 383.3L362.6 375.9L417.6 392.1L454.7 327.9L413.2 288.4L414.7 276.4C415.6 269.7 416 262.9 416 256C416 249.1 415.6 242.3 414.7 235.6L413.2 223.6L454.7 184.1L417.6 119.9L362.6 136.1L352.9 128.7C342.2 120.5 330.4 113.6 317.7 108.3L306.5 103.6L293.1 48H218.9L205.5 103.6z"
            })
        })
    }));
};
/* harmony default export */ var Gear = (Gear_Icon);

;// CONCATENATED MODULE: ./units/Icon/ShareNodes.tsx




var ShareNodes_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M448 112C448 156.2 412.2 192 368 192C345.1 192 324.4 182.4 309.9 166.1L158.9 242.5C159.6 246.9 160 251.4 160 256C160 260.6 159.6 265.1 158.9 269.5L309.9 345C324.4 329.6 345.1 320 368 320C412.2 320 448 355.8 448 400C448 444.2 412.2 480 368 480C323.8 480 288 444.2 288 400C288 390.3 289.7 380.1 292.9 372.3L147.2 299.5C132.9 321.5 108.2 336 80 336C35.82 336 0 300.2 0 256C0 211.8 35.82 176 80 176C108.2 176 132.9 190.5 147.2 212.5L292.9 139.7C289.7 131 288 121.7 288 112C288 67.82 323.8 32 368 32C412.2 32 448 67.82 448 112L448 112zM79.1 304C106.5 304 127.1 282.5 127.1 256C127.1 229.5 106.5 208 79.1 208C53.49 208 31.1 229.5 31.1 256C31.1 282.5 53.49 304 79.1 304zM368 64C341.5 64 320 85.49 320 112C320 138.5 341.5 160 368 160C394.5 160 416 138.5 416 112C416 85.49 394.5 64 368 64zM368 448C394.5 448 416 426.5 416 400C416 373.5 394.5 352 368 352C341.5 352 320 373.5 320 400C320 426.5 341.5 448 368 448z"
            })
        })
    }));
};
/* harmony default export */ var ShareNodes = (ShareNodes_Icon);

;// CONCATENATED MODULE: ./units/Icon/CameraViewFinder.tsx




var CameraViewFinder_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 576 512",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 48C0 21.49 21.49 0 48 0H144C152.8 0 160 7.164 160 16C160 24.84 152.8 32 144 32H48C39.16 32 32 39.16 32 48V144C32 152.8 24.84 160 16 160C7.164 160 0 152.8 0 144V48zM320 256C320 291.3 291.3 320 256 320C220.7 320 192 291.3 192 256C192 220.7 220.7 192 256 192C291.3 192 320 220.7 320 256zM256 224C238.3 224 224 238.3 224 256C224 273.7 238.3 288 256 288C273.7 288 288 273.7 288 256C288 238.3 273.7 224 256 224zM325.8 111.6L332 128H360C390.9 128 416 153.1 416 184V328C416 358.9 390.9 384 360 384H152C121.1 384 96 358.9 96 328V184C96 153.1 121.1 128 152 128H180L186.2 111.6C189.7 102.2 198.6 96 208.6 96H303.4C313.4 96 322.3 102.2 325.8 111.6zM152 160C138.7 160 128 170.7 128 184V328C128 341.3 138.7 352 152 352H360C373.3 352 384 341.3 384 328V184C384 170.7 373.3 160 360 160H309.8L297.8 128H214.2L202.2 160H152zM464 0C490.5 0 512 21.49 512 48V144C512 152.8 504.8 160 496 160C487.2 160 480 152.8 480 144V48C480 39.16 472.8 32 464 32H368C359.2 32 352 24.84 352 16C352 7.164 359.2 0 368 0H464zM0 368C0 359.2 7.164 352 16 352C24.84 352 32 359.2 32 368V464C32 472.8 39.16 480 48 480H144C152.8 480 160 487.2 160 496C160 504.8 152.8 512 144 512H48C21.49 512 0 490.5 0 464V368zM368 512C359.2 512 352 504.8 352 496C352 487.2 359.2 480 368 480H464C472.8 480 480 472.8 480 464V368C480 359.2 487.2 352 496 352C504.8 352 512 359.2 512 368V464C512 490.5 490.5 512 464 512H368z"
            })
        })
    }));
};
/* harmony default export */ var CameraViewFinder = (CameraViewFinder_Icon);

;// CONCATENATED MODULE: ./units/Icon/Eye.tsx



var Eye_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "26",
        height: "27",
        viewBox: "0 0 26 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.08301 13.5002C1.08301 13.5002 5.41634 4.8335 12.9997 4.8335C20.583 4.8335 24.9163 13.5002 24.9163 13.5002C24.9163 13.5002 20.583 22.1668 12.9997 22.1668C5.41634 22.1668 1.08301 13.5002 1.08301 13.5002Z",
                stroke: "white",
                strokeWidth: "2.16667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.9997 16.7502C14.7946 16.7502 16.2497 15.2951 16.2497 13.5002C16.2497 11.7052 14.7946 10.2502 12.9997 10.2502C11.2047 10.2502 9.74967 11.7052 9.74967 13.5002C9.74967 15.2951 11.2047 16.7502 12.9997 16.7502Z",
                stroke: "white",
                strokeWidth: "2.16667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var Eye = (Eye_Icon);

;// CONCATENATED MODULE: ./units/Icon/Document.tsx



var Document_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        stroke: "white",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.5127 2.5H6.5127C5.98226 2.5 5.47355 2.71071 5.09848 3.08579C4.72341 3.46086 4.5127 3.96957 4.5127 4.5V20.5C4.5127 21.0304 4.72341 21.5391 5.09848 21.9142C5.47355 22.2893 5.98226 22.5 6.5127 22.5H18.5127C19.0431 22.5 19.5518 22.2893 19.9269 21.9142C20.302 21.5391 20.5127 21.0304 20.5127 20.5V8.5M14.5127 2.5L20.5127 8.5M14.5127 2.5V8.5H20.5127M16.5127 13.5H8.5127M16.5127 17.5H8.5127M10.5127 9.5H8.5127",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
/* harmony default export */ var Document = (Document_Icon);

;// CONCATENATED MODULE: ./units/Icon/Video.tsx



var Video_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        stroke: "white",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2634_120422)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M23.5 7L16.5 12L23.5 17V7Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.5 5H3.5C2.39543 5 1.5 5.89543 1.5 7V17C1.5 18.1046 2.39543 19 3.5 19H14.5C15.6046 19 16.5 18.1046 16.5 17V7C16.5 5.89543 15.6046 5 14.5 5Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2634_120422",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Video = (Video_Icon);

;// CONCATENATED MODULE: ./units/Icon/FullScreen.tsx



var FullScreen_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4 9.5L4 6.1C4 5.53995 4 5.25992 4.10899 5.04601C4.20487 4.85785 4.35785 4.70487 4.54601 4.609C4.75992 4.5 5.03995 4.5 5.6 4.5L9 4.5M4 15.5V18.9C4 19.4601 4 19.7401 4.10899 19.954C4.20487 20.1422 4.35785 20.2951 4.54601 20.391C4.75992 20.5 5.03995 20.5 5.6 20.5H9M15 4.5H18.4C18.9601 4.5 19.2401 4.5 19.454 4.60899C19.6422 4.70487 19.7951 4.85785 19.891 5.04601C20 5.25992 20 5.53995 20 6.1V9.5M20 15.5V18.9C20 19.4601 20 19.7401 19.891 19.954C19.7951 20.1422 19.6422 20.2951 19.454 20.391C19.2401 20.5 18.9601 20.5 18.4 20.5H15",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
/* harmony default export */ var FullScreen = (FullScreen_Icon);

;// CONCATENATED MODULE: ./units/Icon/IotPressureMeter.tsx



var IotPressureMeter_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_3367_28519)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.7529 8.84961C10.2697 8.84961 9.87793 9.24136 9.87793 9.72461V14.3338C9.35485 14.6363 9.00293 15.2018 9.00293 15.8496C9.00293 16.8161 9.7864 17.5996 10.7529 17.5996C11.7195 17.5996 12.5029 16.8161 12.5029 15.8496C12.5029 15.2018 12.151 14.6363 11.6279 14.3338V9.72461C11.6279 9.24136 11.2362 8.84961 10.7529 8.84961Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.87793 6.22454C9.87793 5.7413 10.2697 5.34954 10.7529 5.34954C11.2362 5.34954 11.6279 5.7413 11.6279 6.22454C11.6279 6.70779 11.2362 7.09954 10.7529 7.09954C10.2697 7.09954 9.87793 6.70779 9.87793 6.22454Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.2529 7.09968C13.7697 7.09968 13.3779 7.49143 13.3779 7.97468C13.3779 8.45793 13.7697 8.84968 14.2529 8.84968C14.7362 8.84968 15.1279 8.45793 15.1279 7.97468C15.1279 7.49143 14.7362 7.09968 14.2529 7.09968Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.50293 12.3495C5.01968 12.3495 4.62793 11.9578 4.62793 11.4745C4.62793 10.9913 5.01968 10.5995 5.50293 10.5995C5.98617 10.5995 6.37793 10.9913 6.37793 11.4745C6.37793 11.9578 5.98617 12.3495 5.50293 12.3495Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.37793 7.97468C6.37793 8.45793 6.76968 8.84968 7.25293 8.84968C7.73617 8.84968 8.12793 8.45792 8.12793 7.97468C8.12793 7.49143 7.73617 7.09968 7.25293 7.09968C6.76968 7.09968 6.37793 7.49143 6.37793 7.97468Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.0029 12.3495C15.5197 12.3495 15.1279 11.9578 15.1279 11.4745C15.1279 10.9913 15.5197 10.5995 16.0029 10.5995C16.4862 10.5995 16.8779 10.9913 16.8779 11.4745C16.8779 11.9578 16.4862 12.3495 16.0029 12.3495Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.7529 21.0997C16.0686 21.0997 20.3779 16.7904 20.3779 11.4747C20.3779 6.15894 16.0686 1.84968 10.7529 1.84968C5.43719 1.84968 1.12793 6.15894 1.12793 11.4747C1.12793 16.7904 5.43719 21.0997 10.7529 21.0997ZM10.7529 19.3437C6.40699 19.3437 2.88391 15.8206 2.88391 11.4747C2.88391 7.12874 6.40699 3.60565 10.7529 3.60565C15.0989 3.60565 18.622 7.12874 18.622 11.4747C18.622 15.8206 15.0989 19.3437 10.7529 19.3437Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3367_28519",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "21",
                        height: "21",
                        fill: "white",
                        transform: "translate(0.25293 0.974609)"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var IotPressureMeter = (IotPressureMeter_Icon);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./units/Icon/Attention.tsx




var SVGComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 56,
        height: 56,
        viewBox: "0 0 56 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: 4,
                y: 4,
                width: 48,
                height: 48,
                rx: 24,
                fill: "#FEF0C7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: 4,
                y: 4,
                width: 48,
                height: 48,
                rx: 24,
                stroke: "#FFFAEB",
                strokeWidth: 8
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.9998 24.0002V28.0002M27.9998 32.0002H28.0098M26.2898 18.8602L17.8198 33.0002C17.6451 33.3026 17.5527 33.6455 17.5518 33.9947C17.5508 34.3439 17.6413 34.6873 17.8142 34.9907C17.9871 35.2941 18.2365 35.547 18.5375 35.7241C18.8385 35.9012 19.1806 35.9964 19.5298 36.0002H36.4698C36.819 35.9964 37.1611 35.9012 37.4621 35.7241C37.7631 35.547 38.0124 35.2941 38.1854 34.9907C38.3583 34.6873 38.4488 34.3439 38.4478 33.9947C38.4468 33.6455 38.3544 33.3026 38.1798 33.0002L29.7098 18.8602C29.5315 18.5663 29.2805 18.3233 28.981 18.1547C28.6814 17.9861 28.3435 17.8975 27.9998 17.8975C27.656 17.8975 27.3181 17.9861 27.0186 18.1547C26.7191 18.3233 26.468 18.5663 26.2898 18.8602Z",
                stroke: "#DC6803",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var Attention = (SVGComponent);

;// CONCATENATED MODULE: ./units/Icon/FilePDF.tsx




var FilePDF_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        fill: "none"
    }, props), {
        viewBox: "0 0 20 26.666",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "FilePDF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "white",
                d: "M20 23.334a3.337 3.337 0 0 1 -3.333 3.333H3.333A3.335 3.335 0 0 1 0 23.334h1.667A1.665 1.665 0 0 0 3.333 25h13.334a1.665 1.665 0 0 0 1.667 -1.667zM12.5 10c-1.38 0 -2.5 -1.12 -2.5 -2.5V1.667H3.333a1.667 1.667 0 0 0 -1.667 1.667v8.334H0V3.333A3.333 3.333 0 0 1 3.333 0h8.13a2.51 2.51 0 0 1 1.771 0.733l6.031 6.033A2.51 2.51 0 0 1 20 8.537v3.13h-1.667V10zm5.588 -2.052L12.052 1.911a0.8 0.8 0 0 0 -0.386 -0.22V7.5c0 0.459 0.375 0.834 0.834 0.834h5.808a0.8 0.8 0 0 0 -0.219 -0.386M4.583 13.334c1.609 0 2.917 1.308 2.917 2.917s-1.308 2.917 -2.917 2.917h-0.416v1.667c0 0.459 -0.373 0.834 -0.834 0.834S2.5 21.291 2.5 20.833V14.166a0.835 0.835 0 0 1 0.834 -0.834zm1.25 2.917c0 -0.693 -0.557 -1.25 -1.25 -1.25h-0.416v2.5h0.416c0.693 0 1.25 -0.557 1.25 -1.25m2.5 -2.083c0 -0.459 0.375 -0.834 0.834 -0.834h1.25c1.38 0 2.5 1.12 2.5 2.5v3.333c0 1.38 -1.12 2.5 -2.5 2.5h-1.25c-0.459 0 -0.834 -0.375 -0.834 -0.834zM10 20h0.416c0.459 0 0.834 -0.375 0.834 -0.834v-3.333c0 -0.459 -0.375 -0.834 -0.834 -0.834H10zm7.5 -6.667c0.459 0 0.834 0.375 0.834 0.834s-0.375 0.834 -0.834 0.834h-1.667v1.667H17.5c0.459 0 0.834 0.375 0.834 0.834s-0.375 0.834 -0.834 0.834h-1.667v2.5c0 0.459 -0.375 0.834 -0.834 0.834s-0.834 -0.375 -0.834 -0.834V14.166c0 -0.459 0.375 -0.834 0.834 -0.834z"
            })
        ]
    }));
};
/* harmony default export */ var FilePDF = (FilePDF_Icon);

;// CONCATENATED MODULE: ./units/Icon/Delete.tsx




/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "20",
    height: "22",
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M1 5H3M3 5H19M3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V5H3ZM6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5M8 10V16M12 10V16",
        stroke: "#D92D20",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
var Delete_Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 20,
        height: 22,
        viewBox: "0 0 20 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 5H3M3 5H19M3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V5H3ZM6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5M8 10V16M12 10V16",
            stroke: "#D92D20",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
/* harmony default export */ var Delete = (Delete_Icon);

;// CONCATENATED MODULE: ./units/Icon/index.ts





















































var collection = {
    ArrowDown: ArrowDown,
    ArrowUp: ArrowUp,
    ArrowRight: ArrowRight,
    ChevronDown: ChevronDown,
    ChevronLeft: ChevronLeft,
    ChevronRight: ChevronRight,
    Close: Close,
    ColorPalette: ColorPalette,
    Droplet: Droplet,
    Edit: Edit,
    ExpandArrowsAlt: ExpandArrowsAlt,
    Filter: Filter,
    Image: Image,
    Layout: Layout,
    Loading: Loading,
    Lock: Lock,
    MetroShrink: MetroShrink,
    Redo: Redo,
    Resize: Resize,
    Ruler: Ruler,
    Search: Search,
    SortAlphaDown: SortAlphaDown,
    SortAlphaUp: SortAlphaUp,
    Tag: Tag,
    ToggleOn: ToggleOn,
    ToggleOff: ToggleOff,
    Undo: Undo,
    Upload: Upload,
    Public: Public,
    Add: Add,
    Print: Icon_Print,
    Star: Star,
    StarSolid: StarSolid,
    Bars: Bars,
    Xmark: Xmark,
    Check: Check,
    ExclamationMark: ExclamationMark,
    Info: Info,
    Warning: Warning,
    Gear: Gear,
    ShareNodes: ShareNodes,
    CameraViewFinder: CameraViewFinder,
    Book: Book,
    Backpack: Backpack,
    GalleryThumbnails: GalleryThumbnails,
    Eye: Eye,
    Document: Document,
    Video: Video,
    FullScreen: FullScreen,
    IotPressureMeter: IotPressureMeter,
    Attention: Attention,
    FilePDF: FilePDF,
    Delete: Delete
};
/* harmony default export */ var units_Icon = (collection);


/***/ })

}]);